import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";

const fetch = (context, params) => {
  return ReqTrasladoService.fetch(params)
    .then(res => {
      context.commit('REQS_TRASLADO', res.data);
    });
};

export default {
  fetch,
};